import { Fields as MerchantFields } from 'models/Merchant'
import { matchesAnyProvider } from 'utilities/posProviders'

// The strings below are `Pos::Provider#value`s as served by the merchant API
// in `merchant.all_redemption_providers[].value` (nucleus `pos_providers`
// table). There is NO backend constant that classifies a POS as
// unsupported/coming-soon for promo codes — that grouping is a frontend
// product decision, so these lists are the source of truth for the banner and
// must be updated by hand when product changes which POS can redeem promo
// codes in-store (or when a new POS `value` is added server-side).

// POS systems that cannot redeem universal promo codes in-store. Merchants on
// any of these can only use promo codes for online and app orders, so
// promo-code pages surface a warning banner explaining the limitation.
export const UNSUPPORTED_PROMO_POS = ['qu', 'franpos', 'shift4']

// POS systems where in-store promo code redemption is not available yet but is
// on the roadmap. These merchants see a "coming soon" banner rather than the
// permanent "not available" one.
export const COMING_SOON_PROMO_POS = ['toast']

const UNSUPPORTED_PROMO_POS_SET = new Set(UNSUPPORTED_PROMO_POS)
const COMING_SOON_PROMO_POS_SET = new Set(COMING_SOON_PROMO_POS)

/**
 * True when ANY of the merchant's redemption providers is a POS that does not
 * support in-store promo code redemption. A merchant with a mix of supported
 * and unsupported providers still surfaces the banner, since at least some of
 * their locations cannot redeem codes in-store.
 */
export const hasUnsupportedPromoPos = (
  merchant: MerchantFields | null | undefined
): boolean => matchesAnyProvider(merchant, UNSUPPORTED_PROMO_POS_SET)

/**
 * True when ANY of the merchant's redemption providers is a POS where in-store
 * promo code redemption is coming soon (Toast).
 */
export const hasComingSoonPromoPos = (
  merchant: MerchantFields | null | undefined
): boolean => matchesAnyProvider(merchant, COMING_SOON_PROMO_POS_SET)
